export const AAASMessages = {
  UPGRADE_BUTTON_CLICKED: 'UPGRADE_BUTTON_CLICKED',
  SEE_ALL_PLANS_CLICKED: 'SEE_ALL_PLANS_CLICKED',
  SUBSCRIPTION_UPGRADED: 'SUBSCRIPTION_UPGRADED',
};

export const AaasModalNames = {
  freeTrialEnded_14days_accountSubscription_noFreePlan: 'freeTrialEnded_14days_accountSubscription_noFreePlan', // used by Usercentrics VISA-14210
  subscriptionEnded_accountSubscription_noFreePlan: 'subscriptionEnded_accountSubscription_noFreePlan', // used by Usercentrics VISA-14287
};

export const AAAS_NO_AUTH_ROUTES = ['/generate-impersonate'];
